<template>
  <GridViewPlantsWithDates>
    <CardItemPlantaAbateProgramacao />
    <DialogConfirmarAlteracoes
      :dialog="dialogConfirmarProgramacao"
      @cancelarConfirmacao="closeDialogConfirmar"
      @sendConfirmarProgramacao="sendConfirmarProgramacao"
      window="programacao"
      :heightTotal="240"
    />
  </GridViewPlantsWithDates>
</template>

<script>
import { mapActions, mapState } from "vuex";

import GridViewPlantsWithDates from "../components/GridViewPlantsWithDates.vue";
import CardItemPlantaAbateProgramacao from "../components/CardItemPlantaAbateProgramacao.vue";
import DialogConfirmarAlteracoes from "../components/DialogConfirmarAlteracoes.vue";

export default {
  name: "Programacao",
  components: {
    GridViewPlantsWithDates,
    CardItemPlantaAbateProgramacao,
    DialogConfirmarAlteracoes,
  },
  props: {
    confirmarProgramacao: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogConfirmarProgramacao: false,
    };
  },
  computed: {},
  methods: {
    ...mapActions("programacaoAbate", ["ActionConfirmarLotes"]),
    openConfirmarProgramacao(value) {
      this.dialogConfirmarProgramacao = value;
    },
    closeDialogConfirmar() {
      this.dialogConfirmarProgramacao = false;
      this.$emit("cancelConfirmarProgramacao");
    },
    sendConfirmarProgramacao() {
      this.ActionConfirmarLotes(4);
      this.closeDialogConfirmar();
    },
  },
  watch: {
    confirmarProgramacao(newValue, oldValue) {
      this.openConfirmarProgramacao(newValue);
    },
  },
};
</script>

<style lang="scss">
</style>
